import type { ApiClient } from "./client"
import { createAdminEndpoints } from "./endpoints/admin.ts"
import { createCompanyEndpoints } from "./endpoints/companies.ts"
import { createCustomerEndpoints } from "./endpoints/customer.ts"
import { createMerchantEndpoints } from "./endpoints/merchant.ts"
import { createUserEndpoints } from "./endpoints/users.ts"

export * from "./endpoints/admin.ts"
export * from "./endpoints/companies.ts"
export * from "./endpoints/customer.ts"
export * from "./endpoints/merchant.ts"
export * from "./endpoints/users.ts"

export function createTaktApi(client: ApiClient) {
    return {
        ...createCustomerEndpoints(client),
        ...createAdminEndpoints(client),
        ...createCompanyEndpoints(client),
        ...createMerchantEndpoints(client),
        ...createUserEndpoints(client),
    }
}

export type TaktApi = ReturnType<typeof createTaktApi>
